import React,{useState} from 'react';
import './Sidebar.css';
import NewQuoteIcon from '../../importfiles/Nuovo preventivo.png';
import QuoteshistoryIcon from '../../importfiles/logo-quotes-history.png';
import Logo from '../../importfiles/banjo.png';
import LogoProgetto from '../../importfiles/Chord A.png';
import Frame from '../../importfiles/Frame.png';
import Arrow from '../../importfiles/arrow.png';

const Sidebar = ({ user, onNewQuote, onFetchHistory, history, showHistory, onLoadChat, onOpenProfile }) => {
    const [mobileOpen, setMobileOpen] = useState(false);

    return (
        <>
            {/* Hamburger button — visibile solo su mobile */}
            <button
               className="sidebar-hamburger" 
                onClick={() => setMobileOpen(true)}
                aria-label="Apri menu"
            >
                <img src={Frame} alt="Menu" style={{ width: '50px', height: '50px' }} />
            </button>
            {/* Overlay scuro dietro il drawer */}
            {mobileOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={() => setMobileOpen(false)}
                />
            )}

            {/* Sidebar / Drawer */}
            <div className={`sidebar-container ${mobileOpen ? 'sidebar-open' : ''}`}>

                {/* Bottone chiudi — visibile solo su mobile dentro il drawer */}
                <button
                    className="sidebar-close"
                    onClick={() => setMobileOpen(false)}
                    aria-label="Chiudi menu"
                >
                    <img src={Arrow} alt="Close" style={{ width: '20px', height: '20px' }} />
                </button>

                <div className="sidebar-header">
                    <img src={LogoProgetto} alt="Logo" className="sidebar-logo" />
                      <h1 style={{
                        color: '#5d4037',
                        fontSize: '10px',
                        fontWeight: 'normal',
                        margin: '0 0 10px 0',
                        textAlign: 'center'
                      }}>Structural Health Monitoring, AI and IoT
                    
                </h1>
                </div>
              

                <div className="user-profile2" onClick={onOpenProfile}>
                    <div className="user-avatar">
                        {user?.profileImage ? (
                            <img src={user.profileImage} alt="Profile" className="sidebar-avatar-img" />
                        ) : (
                            <span className="avatar-placeholder">👤</span>
                        )}
                    </div>
                    <span className="user-name">{user ? user.name : 'User Name'}</span>
                </div>

                <nav className="sidebar-nav">
                    <button className="nav-item" onClick={() => { onNewQuote(); setMobileOpen(false); }}>
                        <img src={NewQuoteIcon} alt="" className="nav-icon-img" />
                        <span>New quote</span>
                    </button>

                    <button className="nav-item" onClick={onFetchHistory}>
                        <img src={QuoteshistoryIcon} alt="" className="nav-icon-img2" />
                        <span>Quotes History</span>
                    </button>

                    {showHistory && (
                        <div className="sidebar-history-list">
                            {history.map((chat) => (
                                <div key={chat.chat_id} className="history-chat-item" onClick={() => { onLoadChat(chat.chat_id); setMobileOpen(false); }}>
                                    <span className="history-date">{new Date(chat.timestamp).toLocaleDateString()}</span>
                                    <span className="history-text">{chat.title || "Chat vuota"}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </nav>

                <h1 style={{
                    alignItems: 'center',
                    background: '#0000',
                    border: 'none',
                    color: '#5d4037',
                    cursor: 'pointer',
                    display: 'flex',
                    fontSize: '15px',
                    gap: '12px',
                    padding: '10px',
                    textAlign: 'left',
                    transition: 'transform .2s'
                }}>
                    Beta
                </h1>

                <div className="sidebar-divider"></div>

                <div className="sidebar-footer">
                    <img src={Logo} alt="Banjo Logo" className="footer-logo-image" />
                </div>
            </div>
        </>
    );
};

export default Sidebar;






